'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _redux = require('redux');

var _reactRedux = require('react-redux');

var _reactRouter = require('react-router');

var _CircularProgress = require('material-ui/CircularProgress');

var _CircularProgress2 = _interopRequireDefault(_CircularProgress);

var _years = require('../actions/years');

var _YearForm = require('../components/years/YearForm');

var _YearForm2 = _interopRequireDefault(_YearForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EditYear = function (_React$Component) {
	_inherits(EditYear, _React$Component);

	function EditYear(props) {
		_classCallCheck(this, EditYear);

		var _this = _possibleConstructorReturn(this, (EditYear.__proto__ || Object.getPrototypeOf(EditYear)).call(this, props));

		_this.editYear = _this.editYear.bind(_this);
		_this.redirectToDashboard = _this.redirectToDashboard.bind(_this);
		_this.cancelEdit = _this.cancelEdit.bind(_this);
		return _this;
	}

	_createClass(EditYear, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.props.fetchYearRequest(this.props.match.params.id);
		}
	}, {
		key: 'editYear',
		value: function editYear(year) {
			this.props.editYearRequest(this.props.match.params.id, year, this.redirectToDashboard);
		}
	}, {
		key: 'redirectToDashboard',
		value: function redirectToDashboard() {
			this.props.fetchYearsRequest(this.props.filter);
			this.props.history.push('/years');
		}
	}, {
		key: 'cancelEdit',
		value: function cancelEdit() {
			this.props.editYearCanceled();
			this.redirectToDashboard();
		}
	}, {
		key: 'render',
		value: function render() {
			if (this.props.year === null) {
				return _react2.default.createElement(_CircularProgress2.default, null);
			}

			return _react2.default.createElement(
				'div',
				null,
				_react2.default.createElement(
					'h2',
					null,
					'Editar Ano'
				),
				_react2.default.createElement(_YearForm2.default, {
					year: this.props.year,
					submit: this.editYear,
					cancel: this.cancelEdit
				})
			);
		}
	}]);

	return EditYear;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
	return {
		year: state.years.year
	};
};

var mapDispatchToProps = _extends({}, _years.actionCreators);

exports.default = (0, _reactRouter.withRouter)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(EditYear));
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./src/client/containers/EditYear.js
// module id = 3277
// module chunks = 0